//import { getToken } from '../Auth';
import { readApiErrorPayload, trackApiError } from './ApiErrorTelemetry';
const apiUrl = process.env.REACT_APP_API_BASE_URL;

function buildFilesRequestUrl(assetUrl) {
    return encodeURI(apiUrl + "/api/files?url=" + assetUrl);
}

export function getAssetBlob(url, token) {
    const requestUrl = buildFilesRequestUrl(url);


    return fetch(requestUrl,
                {
                    headers: {
                        'v': '1.0',
                        'accept': 'application/pdf image/*',
                        'Authorization': 'Bearer ' + token,
                        'Cache-Control': 'no-cache, no-store, must-revalidate'
                    }
                })
        
        .then(async response => {
            if (response.ok) {
                const blob = await response.blob();
                return { ok: true, data: blob };
            }

            const apiError = await readApiErrorPayload(response);
            trackApiError('getAssetBlob', 'GET', requestUrl, apiError);

            return { ok: false, data: apiError.message };
        })
        .catch(error => {
            trackApiError('getAssetBlob', 'GET', requestUrl, { message: error.message });
            return { ok: false, data: "Unhandled error:" + error.message };
        });
}

export function getAssetThumbnail(url, token) {
    const requestUrl = buildFilesRequestUrl(url);

    return fetch(requestUrl,
        {
            headers: {
                'v': '1.0',
                'accept': 'application/pdf image/*',
                'Authorization': 'Bearer ' + token,
                'Cache-Control': 'public, max-age=3600'
            }

        })
        .then(async response => {
            if (!response.ok) {
                const apiError = await readApiErrorPayload(response);
                trackApiError('getAssetThumbnail', 'GET', requestUrl, apiError);

                return { ok: false, data: undefined };
            }

            const blob = await response.blob();
            return { ok: true, data: blob };
        })
        .catch(error => {
            trackApiError('getAssetThumbnail', 'GET', requestUrl, { message: error.message });
            return { ok: false, data: undefined };
        });
}